import { AssignBeaconsModalOrganization } from "../../components/configuration/AssignBeaconsModal";
import { BeaconConfigModalBulk } from "../../components/configuration/BeaconConfigModalBulk";
import { UnassignBeaconsButtonOrganization } from "../../components/configuration/UnassignBeaconsButton";

interface OrganizationBeaconTableFooterProps {
  organizationId: string;
  selectedBeaconIds: string[];
  onClearSelectedBeaconIds(): void;
}

export function OrganizationBeaconTableFooter({
  organizationId,
  selectedBeaconIds,
  onClearSelectedBeaconIds,
}: OrganizationBeaconTableFooterProps) {
  return (
    <>
      <BeaconConfigModalBulk selectedBeaconSerials={selectedBeaconIds} />
      <UnassignBeaconsButtonOrganization
        organizationId={organizationId}
        selectedBeaconIds={selectedBeaconIds}
        onClearSelectedBeaconIds={onClearSelectedBeaconIds}
      />
      <AssignBeaconsModalOrganization organizationId={organizationId} />
    </>
  );
}
